/* Use this component to extend specific search components */
import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Controllers } from '@shared/core/controllers';
import * as Tokens from '@shared/core/tokens';
import * as Services from '@shared/core/services';
import { DrawCollapseService } from '@shared/core/directives/drawCollapse';

import { Observable, fromEvent } from 'rxjs';
import { startWith, auditTime, map, take, tap } from 'rxjs/operators';

import { SearchComponent } from '../search.shared.component';

@Component({
    template: '<div>This component requires extending</div>'
})
export class SearchForLocationsComponent extends SearchComponent implements OnInit {
    public preHead: string = 'GOOD MORNING';

    public hasLocations$: Observable<boolean>;
    public isBelowDrawerMediaBreakpoint$: Observable<boolean>;
    public isAutocompleteEnabled$: Observable<boolean>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
        public drawCollapseService: DrawCollapseService,
        public locationsService: Services.LocationsService,
        public routeService: Services.RouteService,
    ) {
        super(config, controllers);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.enableClose = this.enableClose === undefined ? false : this.enableClose;
        this.enableClear = this.enableClear === undefined ? true : this.enableClear;
        this.enableSubmit = this.enableSubmit === undefined ? true : this.enableClear;

        this.searchInput$ = this.controllers.filters.getLocationsSearchInput$();
        this.isAutocompleteEnabled$ = this.controllers.google.isAutocompleteEnabled$();
        this.isBelowDrawerMediaBreakpoint$ = fromEvent(window, 'resize')
            .pipe(
                startWith(null),
                auditTime(200),
                map(() => window.innerWidth < this.drawCollapseService.mediaBreakPoint),
            );

        this.hasLocations$ = this.controllers.locations.hasLocations$();

        if (new Date().getHours() >= 12) {
            this.preHead = 'GOOD AFTERNOON';
        }
    }

    public onSearch(obj: {
        form: FormGroup;
        delivery: APICommon.IGooglePlaceDetails;
        geocoder: APICommon.IGeocoderResult;
    }): Promise<boolean> {
        const value: string = obj.form.controls.searchInput.value || null;

        return new Promise(resolve => {
            this.isDelivery$
                .pipe(
                    take(1)
                ).subscribe(isDelivery => this.controllers.routes.navigateToLocationsSearchView()
                    .then(() => {
                        if (isDelivery) {
                            this.controllers.filters.setLocationFiltersAddress(obj.delivery);
                        } else {
                            this.controllers.filters.setLocationsFiltersSearchTerm(value, obj.geocoder);
                        }

                        resolve(true);
                    }));

        });

    }

    public onSearchReset(form: FormGroup): void {
        this.controllers.filters.clearLocationsFilters();
    }
}
